import moment from 'moment';

export class Message {
  content: string;

  date: Date;

  messageId: string;

  sender: string;

  type: string;

  read: boolean;

  notSent: boolean;

  displayDate: string;

  media: string;

  fileName: string;

  fileType: string;

  constructor(message: any) {
    this.content = message.content;
    if (message.date) {
      const utcDate = moment.utc(message.date);
      const localDate = moment(utcDate).local();
      this.date = localDate.toDate();
      if (localDate.isBefore(moment(), 'year')) {
        this.displayDate = localDate.format('MM/DD/YY');
      } else if (localDate.isBefore(moment(), 'day')) {
        this.displayDate = localDate.format('MM/DD/YY h:mm A');
      } else {
        this.displayDate = localDate.format('h:mm A');
      }
    }
    if (message.media) {
      this.media = decodeURI(message.media);
      this.fileName = this.media.split('/').pop();
      this.fileType = this.media.split('.').pop();
    }
    this.messageId = message.messageId;
    this.sender = message.sender;
    this.type = message.type;
    this.notSent = message.notSent;
    this.read = message.read;
  }
}
